import { ChartDateInterval, EditionPaymentType as EditionPaymentTypeEnum, PaymentPeriodType as PaymentPeriodTypeEnum, SalesSummaryDatePeriod, TenantAvailabilityState } from '@shared/service-proxies/service-proxies';

export class AppTimezoneScope {
    static Application: number = 1;
    static Tenant: number = 2;
    static User: number = 4;
}



export class AppTenantAvailabilityState {
    static Available: number = TenantAvailabilityState._1;
    static InActive: number = TenantAvailabilityState._2;
    static NotFound: number = TenantAvailabilityState._3;
}

export class AppIncomeStatisticsDateInterval {
    static Daily: number = ChartDateInterval._1;
    static Weekly: number = ChartDateInterval._2;
    static Monthly: number = ChartDateInterval._3;
}

export class SubscriptionStartType {

    // static Free: number = RegisterTenantInputSubscriptionStartType._1;
    // static Trial: number = RegisterTenantInputSubscriptionStartType._2;
    // static Paid: number = RegisterTenantInputSubscriptionStartType._3;
}

export class EditionPaymentType {
    static NewRegistration: number = EditionPaymentTypeEnum._0;
    static BuyNow: number = EditionPaymentTypeEnum._1;
    static Upgrade: number = EditionPaymentTypeEnum._2;
    static Extend: number = EditionPaymentTypeEnum._3;
}

export class AppEditionExpireAction {
    static DeactiveTenant = 'DeactiveTenant';
    static AssignToAnotherEdition = 'AssignToAnotherEdition';
}

export class PaymentPeriodType {
    static Monthly: number = PaymentPeriodTypeEnum._30;
    static Annual: number = PaymentPeriodTypeEnum._365;
}

export class SubscriptionPaymentGatewayType {
    static Paypal: number = 1;
}

export class AppSalesSummaryDatePeriod {
    static Daily: number = SalesSummaryDatePeriod._1;
    static Weekly: number = SalesSummaryDatePeriod._2;
    static Monthly: number = SalesSummaryDatePeriod._3;
}

export enum FilterTypes {
    CUSTOM_FILTER,
    SEARCH_TEXT,
    STATUS,
    START_DATE,
    END_DATE,
    WORK_STATUS,
    MANAGERS,
    CASE_OWNERS,
    EMP_STATE,
    RISK,
    ISCANWFH,
    CHECKIN_DATE,
    TESTEDPOSITIVE_DATE,
    ESTRETURN_DATE,
    CASE_STATUS,
    DEPARTMENTS
}
